import Swiper from "swiper";
import { Pagination, Autoplay, Navigation } from "swiper/modules";

export default {
	init() {
		const blocks = document.querySelectorAll('.flip-gallery-carousel-tab-block');
		if (!blocks.length) return;

		blocks.forEach((block) => {
			const slideWrap = block.querySelector(".flip-gallery-carousel-tab-block-inner");
			if (!slideWrap) return;

			const opt = JSON.parse(block.dataset.slider || '{}');

			const items = slideWrap.querySelectorAll('.item-gallery');
			const countItem = items.length;

			const windowWidth = window.innerWidth;

			const breakpointsCheck = [
				{ maxWidth: 576, minItems: 2 },
				{ maxWidth: 992, minItems: 3 },
				{ maxWidth: Infinity, minItems: (opt.slidesToShow || 4) + 1 }
			];

			const breakpoint = breakpointsCheck.find(bp => windowWidth < bp.maxWidth);
			const shouldInit = countItem >= breakpoint.minItems;

			const arrowEditor = block.parentElement.querySelector('.flip-gallery-carousel-tab-block--arrow-editor');

			if (!shouldInit) {
				slideWrap.classList.add('no-carousel');
				arrowEditor?.classList.add('no-carousel');
				return;
			}

			const swiper = new Swiper(slideWrap, {
				modules: [Navigation, Pagination, Autoplay],
				loop: true,
				speed: 500,

				autoplay: opt.autoplay ? {
					delay: 3000,
					disableOnInteraction: false
				} : false,

				navigation: {
					nextEl: block.querySelector('.swiper-button-next'),
					prevEl: block.querySelector('.swiper-button-prev')
				},

				pagination: opt.dots ? {
					el: block.querySelector('.swiper-pagination'),
					clickable: true
				} : false,

				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 20
					},
					992: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					1200: {
						slidesPerView: opt.slidesToShow || 4,
						spaceBetween: 40
					}
				}
			});

			let atStart = false;
			let atEnd = false;

			swiper.on('slideChange', () => {
				atStart = swiper.isBeginning;
				atEnd = swiper.isEnd;
			});

			function switchTab(direction, slideWrap) {
				const blockTabs = slideWrap.closest('.flip-tabs-wrapper');
				if (!blockTabs) return;

				const currentContainer = slideWrap.closest('.flip-tab-body-container');
				currentContainer.classList.remove('active');

				// stop all swiper
				blockTabs.querySelectorAll('.swiper').forEach(sw => {
					sw.swiper?.autoplay?.stop();
				});

				let targetContainer;

				if (direction === 'next') {
					targetContainer = currentContainer.nextElementSibling?.classList.contains('flip-tab-body-container')
						? currentContainer.nextElementSibling
						: blockTabs.querySelector('.flip-tab-body-container');
				} else {
					targetContainer = currentContainer.previousElementSibling?.classList.contains('flip-tab-body-container')
						? currentContainer.previousElementSibling
						: blockTabs.querySelector('.flip-tab-body-container:last-child');
				}

				targetContainer.classList.add('active');

				const newSwiperEl = targetContainer.querySelector('.flip-gallery-carousel-tab-block-inner');

				if (newSwiperEl?.swiper) {
					setTimeout(() => {
						if (direction === 'next') {
							newSwiperEl.swiper.slideToLoop(0);
						} else {
							newSwiperEl.swiper.slideToLoop(newSwiperEl.swiper.slides.length - 1);
						}
					}, 50);
				}

				// tabs UI
				const tabs = blockTabs.querySelectorAll('ul.flip-tabs-panel li');
				tabs.forEach(tab => tab.classList.remove('flip-tab-active'));

				const index = Array.from(targetContainer.parentElement.children).indexOf(targetContainer);
				tabs[index]?.classList.add('flip-tab-active');
			}

			// arrows (swiper)
			block.addEventListener('click', (e) => {
				if (e.target.closest('.slick-prev')) {
					if (atStart) switchTab('prev', slideWrap);
				}

				if (e.target.closest('.slick-next')) {
					if (atEnd) switchTab('next', slideWrap);
				}

				if (e.target.closest('.item-arrow.prev')) {
					switchTab('prev', slideWrap);
				}

				if (e.target.closest('.item-arrow.next')) {
					switchTab('next', slideWrap);
				}
			});
		});
	}
}